/**
 * 提供在全局获取一些实例的方法
 */
class GlobalInstance {
    setRootVue(vue) {
        this.vue = vue;
    }
    getRootVue() {
        return this.vue;
    }

    setRootStore(store) {
        this.store = store;
    }

    getRootStore() {
        return this.store;
    }

    setComponentsObject(components) {
        this.components = components;
    }

    getComponentsObject() {
        return this.components;
    }

    setMutationsKeys(keys) {
        this.keys = keys;
    }

    getMutationsKeys() {
        return this.keys;
    }

    setComponentMap(componentMap) {
        this.componentMap = componentMap;
    }

    getComponentMap() {
        return this.componentMap;
    }

    setNonConfiguarbleUtil(nonConfiguarbleUtil) {
        this.nonConfiguarbleUtil = nonConfiguarbleUtil;
    }

    getNonConfiguarbleUtil() {
        return this.nonConfiguarbleUtil;
    }

    setBeforeHandleFnList(list) {
        this.beforeHandleFnList = list;
    }

    getBeforeHandleFnList() {
        return this.beforeHandleFnList || [];
    }

    setAfterHandleFnList(list) {
        this.afterHandleFnList = list;
    }

    getAfterHandleFnList() {
        return this.afterHandleFnList || [];
    }
}

export const globalInstance = new GlobalInstance();
